import { render } from "./StudyYear.vue?vue&type=template&id=450c2681&scoped=true"
import script from "./StudyYear.vue?vue&type=script&lang=js"
export * from "./StudyYear.vue?vue&type=script&lang=js"

import "./StudyYear.vue?vue&type=style&index=0&id=450c2681&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450c2681"]])

export default __exports__